import { Link, NavLink, Outlet } from "react-router-dom";
import { Toaster } from "sonner";

export default function Layout() {
  return (
    <div className="min-h-full grid grid-rows-[auto,1fr,auto]">
      <header className="border-b border-border bg-sidebar">
        <div className="max-w-6xl mx-auto px-6 py-4 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-3">
            <img src="/logo.svg" alt="Sricha Bloom" className="h-12 w-auto" />
            <span className="sr-only">Sricha Bloom — Velaa Sindhorn Village, Bangkok</span>
          </Link>
          <nav className="flex items-center gap-6 text-sm">
            {[
              { to: "/", label: "Home" },
              { to: "/order", label: "Order" },
              { to: "/booking", label: "Booking" },
              { to: "/contact", label: "Contact" },
            ].map((i) => (
              <NavLink
                key={i.to}
                to={i.to}
                className={({ isActive }) =>
                  `font-medium transition-colors ${isActive ? "text-accent" : "hover:text-secondary"}`
                }
              >
                {i.label}
              </NavLink>
            ))}
          </nav>
        </div>
      </header>
      <main>
        <Outlet />
      </main>
      <footer className="border-t border-border bg-sidebar">
        <div className="max-w-6xl mx-auto px-6 py-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-sm text-muted-foreground">
            © {new Date().getFullYear()} Sricha Bloom.
          </p>
          <p className="text-sm">Open daily 09:00 – 22:00</p>
        </div>
      </footer>
      <Toaster richColors />
    </div>
  );
}
